






































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
@Component({
  name: 'TitleIndex',
})
export default class extends Vue {
  @Prop() private flag!: any
  @Prop() private tateData!: any
  @Prop() private turnoverData!: any

  nowIndex = 0
  value = []
  tabsParam = ['本周', '本月', '自定义']
  dateRange = []

  created() {
    // 初始化时同步flag和nowIndex
    this.nowIndex = this.flag - 1
  }

  @Watch('flag')
  getNowIndex(val) {
    // 确保flag变化时，nowIndex正确更新 (flag是1-based, nowIndex是0-based)
    this.nowIndex = val - 1
  }
  
  // tab切换
  toggleTabs(index: number) {
    this.nowIndex = index
    this.value = []
    if (index === 2) {
      // 自定义日期，不触发父组件事件，等待日期选择
      if (this.dateRange && this.dateRange.length === 2) {
        this.$emit('sendCustomDate', this.dateRange[0], this.dateRange[1])
      }
    } else {
      this.$emit('sendTitleInd', index + 1)
    }
  }
  
  // 处理日期变化
  handleDateChange(val) {
    if (val && val.length === 2) {
      this.nowIndex = 2 // 切换到自定义标签
      this.$emit('sendCustomDate', val[0], val[1])
    }
  }
  

}
